import { useQuery, gql } from "@apollo/client"
import { CollectionMetadata, Engagement, Maybe } from "@oysterhr/schema"
import { PER_PAGE } from "../../constants"
import { MONEY_FIELDS } from "~/shared/fragments/MoneyFields"

const ENGAGEMENTS_QUERY = gql`
  ${MONEY_FIELDS}
  query BenefitsCompanyEnrollments($companyId: ID!, $query: String, $perPage: Int, $page: Int) {
    company(companyId: $companyId) {
      engagements(query: $query, states: [ENGAGED, IN_PROGRESS], perPage: $perPage, page: $page) {
        metadata {
          totalPages
          totalCount
          currentPage
          limitValue
        }
        collection {
          id
          isPayrollTeamMember
          teamMemberName
          countryCode
          teamMember {
            avatarUrl
            id
          }
          employment {
            id
          }
          contract {
            id
          }
          role
          benefitsEnrollments {
            collection {
              id
              state
              totalPriceInvoicedCompany {
                ...MoneyFields
              }
              plan {
                name
                descriptiveName
                provider {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`

type ResultType = {
  company: {
    engagements: {
      metadata: CollectionMetadata
      collection: Engagement[]
    }
  }
}

export function useCompanyEngagements({
  companyStrongId,
  page,
  query,
  perPage = PER_PAGE,
}: {
  companyStrongId: string
  page: number
  query?: Maybe<string>
  perPage?: number
}) {
  return useQuery<ResultType>(ENGAGEMENTS_QUERY, {
    variables: {
      companyId: `Company:${companyStrongId}`,
      query,
      page,
      perPage,
    },
    // there is a bug in the caching of apollo. It returns an empty array for some reason
    fetchPolicy: "no-cache",
  })
}
